import { jsx as _jsx } from "react/jsx-runtime";
import { uploadUxPanelImage } from '../../api/ux-panel-images';
import { EntityBulkUploadModal } from '../EntityBulkUploadModal/EntityBulkUploadModal';
export const UxPanelsBulkUploadModal = (props) => (_jsx(EntityBulkUploadModal, Object.assign({}, props, { title: "Bulk Upload UX Panel Images", upload: uploadUxPanelImage, uploadView: "compact", resultView: "fileList" })));
